import { CardHistoryTrans } from '@/entities/profile-page/historyTransactions/CardHistoryTrans/ui/CardHistoryTrans'
import './ui/CardHistoryTrans.scss'
export default CardHistoryTrans
